import { render, staticRenderFns } from "./LargeRadio.vue?vue&type=template&id=5811766d"
import script from "./LargeRadio.vue?vue&type=script&lang=js"
export * from "./LargeRadio.vue?vue&type=script&lang=js"
import style0 from "./LargeRadio.vue?vue&type=style&index=0&id=5811766d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports